// extracted by mini-css-extract-plugin
export default {"cartlist":"ItemsList_cartlist__8EPZa","infoMsg":"ItemsList_infoMsg__rex32"};